import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class GlobalAdminAnalyticsService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getNewPatientCount(input) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/admin/analytics/new-patients`, {
            ...(await authenticatedApiConfig(this.authenticationProvider)),
            params: {
                startDate: input.startDate.toISOString(),
                endDate: input.endDate.toISOString(),
            },
        });
        return response.data;
    }
}
